import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import Tooltip from 'gnos-tooltip'

import cx from 'classnames'

import './style.scss'

export default class BisnodeScoring extends Component {
    static propTypes = {
        clickHandler: PropTypes.func,
        clickIdentifier: PropTypes.string.isRequired,
        data: PropTypes.object,
        headerMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        identifier: PropTypes.string.isRequired,
        isLight: PropTypes.bool,
        naDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    }

    handleOnClick = () => {
        const { clickHandler, clickIdentifier } = this.props

        if (clickHandler) {
            clickHandler(clickIdentifier)
        }
    }

    render() {
        const { headerMessage, identifier, tooltip, data, isLight, naDescription } = this.props

        const content = (
            <div className={cx('indicator-item', 'bisnode-scoring-section')}>
                <div className={'indicator-item-header'}>{headerMessage}</div>
                <div className={'bisnode-scoring-content'} onClick={this.handleOnClick}>
                    {isLight && data ? (
                        <div className={cx('indicators-image', `light-${_.get(data, 'value', null)}`)} />
                    ) : (
                        <div
                            className={cx('scoring-code', _.get(data, 'value', null))}
                            style={{
                                color: _.get(data, 'color'),
                            }}
                        >
                            {!_.isNil(_.get(data, 'code', null)) && _.get(data, 'code', null) !== 'NG'
                                ? _.get(data, 'code', null)
                                : 'N/A'}
                        </div>
                    )}
                    <div className={'scoring-description'}>
                        {data && !_.isNil(data.description) ? data.description : naDescription}
                    </div>
                    <div className={cx('indicator-item-footer ', 'magnifier')} />
                </div>
            </div>
        )

        return tooltip ? (
            <Tooltip id={`indicator_tooltip_${identifier}`} content={tooltip} key={`indicator_tooltip_${identifier}`}>
                {content}
            </Tooltip>
        ) : (
            content
        )
    }
}
